import axios from 'axios';

let baseURL = process.env.baseURL || "https://tiranomusic.com/tiranomusic/api";

let instance = axios.create({
	baseURL
});

export const HTTP = instance;